// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"87":"296bf2fe","245":"030bf090","361":"08be2ae6","823":"055a4ae0","872":"cacdfa82"}[chunkId] + ".chunk.css";
};